import React, { useState } from "react";
import {
  message,
  Modal,
  Form,
  Input,
  // DatePicker,
  // Checkbox,
} from "antd";
import {
  collectionAPIWithErrorHandling,
  collectionHelpers,
} from "../../../api/collection/collection";

// Duplicate Modal Component
const DuplicateModal = ({ visible, onCancel, onSuccess, collection }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      setLoading(true);

      const options = {
        name: values.name,
        // ...(values.updateDates && {
        //   start_date: values.start_date.format('YYYY-MM-DD'),
        //   end_date: values.end_date.format('YYYY-MM-DD'),
        // }),
        // copy_customer_fees: values.copy_customer_fees ?? true,
        // copy_fee_definitions: values.copy_fee_definitions ?? true,
      };

      // Validate options
      const validation = collectionHelpers.validateDuplicateOptions(options);
      if (!validation.isValid) {
        Object.values(validation.errors).forEach(error => {
          message.error(error);
        });
        return;
      }

      const response = await collectionAPIWithErrorHandling.duplicateCollection(
        collection.id,
        options
      );

      message.success('Sao chép đợt thu thành công!');
      form.resetFields();
      onSuccess(response);
    } catch (error) {
      message.error(error.message || 'Không thể sao chép đợt thu');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title={`Sao chép đợt thu: ${collection?.name}`}
      open={visible}
      onCancel={() => {
        form.resetFields();
        onCancel();
      }}
      onOk={handleSubmit}
      confirmLoading={loading}
      width={600}
      okText="Sao chép"
      cancelText="Hủy"
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={{
          name: collectionHelpers.generateDuplicateName(collection?.name || ''),
          // updateDates: false,
          // copy_customer_fees: true,
          // copy_fee_definitions: true,
        }}
      >
        <Form.Item
          label="Tên đợt thu mới"
          name="name"
          rules={[
            { required: true, message: 'Vui lòng nhập tên đợt thu' },
            { max: 255, message: 'Tên không được vượt quá 255 ký tự' },
          ]}
        >
          <Input placeholder="Nhập tên đợt thu mới" />
        </Form.Item>

        {/* <Form.Item name="updateDates" valuePropName="checked">
          <Checkbox>Cập nhật thời gian đợt thu</Checkbox>
        </Form.Item>

        <Form.Item noStyle shouldUpdate={(prev, curr) => prev.updateDates !== curr.updateDates}>
          {({ getFieldValue }) =>
            getFieldValue('updateDates') ? (
              <>
                <Form.Item
                  label="Ngày bắt đầu"
                  name="start_date"
                  rules={[{ required: true, message: 'Vui lòng chọn ngày bắt đầu' }]}
                >
                  <DatePicker
                    style={{ width: '100%' }}
                    format="DD/MM/YYYY"
                    placeholder="Chọn ngày bắt đầu"
                  />
                </Form.Item>

                <Form.Item
                  label="Ngày kết thúc"
                  name="end_date"
                  rules={[
                    { required: true, message: 'Vui lòng chọn ngày kết thúc' },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        const startDate = getFieldValue('start_date');
                        if (!value || !startDate || value.isAfter(startDate)) {
                          return Promise.resolve();
                        }
                        return Promise.reject(new Error('Ngày kết thúc phải sau ngày bắt đầu'));
                      },
                    }),
                  ]}
                >
                  <DatePicker
                    style={{ width: '100%' }}
                    format="DD/MM/YYYY"
                    placeholder="Chọn ngày kết thúc"
                  />
                </Form.Item>
              </>
            ) : null
          }
        </Form.Item>

        <Form.Item name="copy_customer_fees" valuePropName="checked">
          <Checkbox>Sao chép danh sách khách hàng và phí</Checkbox>
        </Form.Item>

        <Form.Item name="copy_fee_definitions" valuePropName="checked">
          <Checkbox>Sao chép định nghĩa các loại phí</Checkbox>
        </Form.Item> */}
      </Form>
    </Modal>
  );
};


export default DuplicateModal;